document.addEventListener('DOMContentLoaded', function () {
    // Remove no-JS guard class
    document.documentElement.classList.remove('hide-scroll');

    // add-remove class on scroll
    const siteHeader = document.querySelector('.site-header');
    window.addEventListener('scroll', function () {
        const scroll = window.scrollY;
        if (siteHeader) {
            siteHeader.classList.toggle('scrolled', scroll >= 300);
        }
    });

    // smooth scroll
    document.querySelectorAll('a.scroll-to[href*="#"], a.ez-toc-link[href*="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            const target = document.querySelector(link.getAttribute('href'));
            if (!target) return;
            e.preventDefault();
            window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - 100,
                behavior: 'smooth',
            });
        });
    });

    // ----------------------------------------------------------------
    // Mobile menu toggle
    // ----------------------------------------------------------------
    const menuToggle = document.querySelector('.js-open-menu');
    const mobileMenu = document.getElementById('mobile-menu');

    if (menuToggle && mobileMenu) {
        menuToggle.addEventListener('click', function () {
            const isOpen = document.body.classList.toggle('menu-opened');
            mobileMenu.hidden = !isOpen;
            mobileMenu.classList.toggle('open');
            menuToggle.setAttribute('aria-expanded', String(isOpen));
        });

        // Initialise hidden attribute on load
        mobileMenu.hidden = true;
        menuToggle.setAttribute('aria-expanded', 'false');
    }

    // ----------------------------------------------------------------
    // Header search toggle
    // ----------------------------------------------------------------
    const searchToggle  = document.querySelector('.js-toggle-search');
    const searchClose   = document.querySelector('.js-close-search');
    const searchOverlay = document.getElementById('header-search-overlay');
    const menuWrap      = document.getElementById('main-menu');
    const searchIconBox = document.querySelector('.header-search-form');

    if (searchToggle && searchOverlay) {
        const openSearch = function () {
            searchOverlay.hidden = false;
            searchOverlay.classList.remove('hidden');
            if (menuWrap) menuWrap.hidden = true;
            if (searchIconBox) searchIconBox.hidden = true;
            searchToggle.setAttribute('aria-expanded', 'true');
            const input = searchOverlay.querySelector('input[type="search"]');
            if (input) input.focus();
        };

        const closeSearch = function () {
            searchOverlay.hidden = true;
            searchOverlay.classList.add('hidden');
            if (menuWrap) menuWrap.hidden = false;
            if (searchIconBox) searchIconBox.hidden = false;
            searchToggle.setAttribute('aria-expanded', 'false');
        };

        searchToggle.addEventListener('click', function (e) {
            e.preventDefault();
            openSearch();
        });

        if (searchClose) {
            searchClose.addEventListener('click', closeSearch);
        }

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !searchOverlay.hidden) {
                closeSearch();
            }
        });
    }

    // ----------------------------------------------------------------
    // Submenu arrow toggles
    // ----------------------------------------------------------------
    document.querySelectorAll('#menu-main-navigation > li.menu-item-has-children, #menu-main-navigation-1 > li.menu-item-has-children').forEach(function (item) {
        const toggle = document.createElement('span');
        toggle.className = 'arrow-toggle';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Toggle submenu');
        toggle.innerHTML = '<svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0117 1.54688L8.29688 7.98047C8.08594 8.15625 7.875 8.22656 7.69922 8.22656C7.48828 8.22656 7.27734 8.15625 7.10156 8.01562L0.351562 1.54688C0 1.23047 0 0.667969 0.316406 0.351562C0.632812 0 1.19531 0 1.51172 0.316406L7.69922 6.22266L13.8516 0.316406C14.168 0 14.7305 0 15.0469 0.351562C15.3633 0.667969 15.3633 1.23047 15.0117 1.54688Z" fill="#fff"/></svg>';
        item.appendChild(toggle);

        toggle.addEventListener('click', function () {
            const submenu = item.querySelector('.sub-menu');
            const isOpen  = item.classList.toggle('open');
            if (submenu) {
                submenu.hidden = !isOpen;
            }
            toggle.setAttribute('aria-expanded', String(isOpen));
        });

        // Initialise hidden state
        const submenu = item.querySelector('.sub-menu');
        if (submenu) submenu.hidden = true;
    });

    // ----------------------------------------------------------------
    // Contact Form 7 — inject custom checkbox markup
    // ----------------------------------------------------------------
    document.querySelectorAll('.wpcf7-checkbox .wpcf7-list-item-label').forEach(function (label) {
        const checkmark = document.createElement('span');
        checkmark.className = 'checkmark';
        label.before(checkmark);
    });

    // ----------------------------------------------------------------
    // Slick sliders — jQuery plugin, requires $()
    // ----------------------------------------------------------------
    (function ($) {
        if ($('.js-home-slider').length) {
            const $slider = $('.js-home-slider');

            $slider.on('init', function (_e, slick) {
                $(slick.$slides[0]).addClass('is-active');
            });

            $slider.on('beforeChange', function (_e, slick, current) {
                // Remove after fade completes so image stays zoomed during transition
                const $outgoing = $(slick.$slides[current]);
                setTimeout(function () {
                    $outgoing.removeClass('is-active');
                }, 1200);
            });

            $slider.on('afterChange', function (_e, slick, current) {
                const $incoming = $(slick.$slides[current]);
                // Force animation restart in case this slide was shown before
                $incoming.removeClass('is-active');
                void $incoming[0].offsetWidth;
                $incoming.addClass('is-active');
            });

            $slider.slick({
                autoplay: true,
                infinite: true,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                fade: true,
                autoplaySpeed: 5000,
                speed: 1200,
                cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
                touchThreshold: 100,
                pauseOnHover: false,
            });
        }
    })(jQuery);

    // ----------------------------------------------------------------
    // Medical Information accordion — one entry open at a time
    // ----------------------------------------------------------------
    document.querySelectorAll('.medical-info__accordion').forEach(function (accordion) {
        const items = accordion.querySelectorAll('.accordion-item');

        items.forEach(function (item) {
            const trigger = item.querySelector('.accordion-item__trigger');
            const panel = item.querySelector('.accordion-item__panel');
            if (!trigger || !panel) return;

            trigger.addEventListener('click', function () {
                const isOpen = item.classList.contains('is-open');

                items.forEach(function (other) {
                    other.classList.remove('is-open');
                    other.querySelector('.accordion-item__trigger').setAttribute('aria-expanded', 'false');
                });

                if (!isOpen) {
                    item.classList.add('is-open');
                    trigger.setAttribute('aria-expanded', 'true');
                }
            });
        });
    });
});
